<label>
  <span>Text</span>
  <textarea
    rows="6"
    [ngModel]="block.textContent"
    placeholder="Landing page copy"
    (ngModelChange)="updateTextContent($event)"></textarea>
</label>
